import React, { useState } from "react";

function InquiryModal({ vendor, onClose, onSend }) {
  const [inquiryType, setInquiryType] = useState('');
  const [message, setMessage] = useState('');
  const types = ['Planning a Future Event','Checking Availability','General Inquiry'];
  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:460,width:'100%',overflow:'hidden'}}>
        <div style={{background:'#1a1410',padding:'20px 24px'}}>
          <div style={{fontSize:14,color:'#a89a8a'}}>Message Vendor</div>
          <div style={{fontSize:20,fontWeight:700,color:'#e8c97a',fontFamily:'Playfair Display,serif'}}>{vendor?.name}</div>
        </div>
        <div style={{padding:'24px'}}>
          <div style={{fontSize:13,fontWeight:600,color:'#1a1410',marginBottom:10}}>What is this inquiry about?</div>
          <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:16}}>
            {types.map(t=>(
              <button key={t} onClick={()=>setInquiryType(t)} style={{textAlign:'left',padding:'10px 14px',borderRadius:8,border:inquiryType===t?'2px solid #c8a850':'1px solid #e8ddd0',background:inquiryType===t?'#fdf9f0':'#fff',cursor:'pointer',fontSize:14,fontWeight:inquiryType===t?600:400,color:'#1a1410',fontFamily:'DM Sans,sans-serif'}}>{t}</button>
            ))}
          </div>
          <div className="form-group" style={{marginBottom:16}}>
            <label>Message (optional)</label>
            <textarea value={message} onChange={e=>setMessage(e.target.value)} rows={3} placeholder="Tell the vendor what you're looking for..." style={{width:'100%',border:'1.5px solid #e0d5c5',borderRadius:8,padding:'10px 14px',fontSize:14,fontFamily:'DM Sans,sans-serif',resize:'vertical',outline:'none',boxSizing:'border-box'}} />
          </div>
          <div style={{fontSize:11,color:'#a89a8a',marginBottom:16,lineHeight:1.5}}>
            Vendor contact info is not shared through general messaging. Contact details are only revealed after an accepted booking on a posted event.
          </div>
          <div style={{display:'flex',gap:10}}>
            <button disabled={!inquiryType} onClick={()=>onSend(inquiryType,message)} style={{flex:2,background:inquiryType?'#1a1410':'#e8ddd0',color:inquiryType?'#e8c97a':'#a89a8a',border:'none',borderRadius:8,padding:'12px 0',fontSize:14,fontWeight:700,cursor:inquiryType?'pointer':'default',fontFamily:'DM Sans,sans-serif'}}>Send Message</button>
            <button onClick={onClose} style={{flex:1,background:'#f5f0ea',color:'#1a1410',border:'1px solid #e0d5c5',borderRadius:8,padding:'12px 0',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InquiryModal;
